import i18n from 'i18next'
// import Backend from 'i18next-xhr-backend'
// import Backend from 'i18next-chained-backend';
import { initReactI18next } from 'react-i18next'
// import LocalStorageBackend from 'i18next-localstorage-backend'
// import HttpApi from 'i18next-http-backend'; // fallback http load
import LanguageDetector from 'i18next-browser-languagedetector';
import { ENVIRONMENT } from "utils/constants.js"

const env = ENVIRONMENT;

import en from 'i18n/translations/en.json';
import sv from 'i18n/translations/sv.json';

// the translations
const resources = {
  en: {
    translation: en,
  },
  sv: {
    translation: sv,
  },
};

i18n
  // .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // backend: {
    //   backends: [
    //     LocalStorageBackend,  // primary
    //     HttpApi               // fallback
    //   ],
    //   backendOptions: [{
    //     /* below options */
    //   }, {
    //     /* translation file path */
    //     loadPath: '/i18n/{{ns}}/{{lng}}.json'
    //   }]
    // },
    fallbackLng: 'sv',
    supportedLngs: ['sv', 'en'],
    debug: env === 'DEV' ? true : false,
    /* can have multiple namespace, in case you want to divide a huge translation into smaller pieces and load them on demand */
    // ns: ['translations'],
    // defaultNS: 'translations',
    keySeparator: ".",
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    },
    react: {
      wait: true
    }
  })

export default i18n